// const baseUrl = "http://localhost:4000/api"
const baseUrl = "https://polar-dusk-67788.herokuapp.com/api"

export default  baseUrl